export const HTTP_UNAUTHORISED = 401;
